export default {
  WAITING: 'waiting',
  PROGRESSING: 'progressing',
  WARNING: 'warning',
  COMPLETED: 'completed',
  ERROR: 'error'
};
